import { FormControl, FormHelperText } from "@mui/material";
import { MuiOtpInput } from "mui-one-time-password-input";
import { Colors } from "../../theme/colors";
import { darkModeField } from "../../theme/darkModeInput";

type IProps = {
  formik: any;
  name: string;
  sx?: any;
};

const classes = {
  field: {
    ...darkModeField,
    "&.MuiOtpInput-TextField": {
      width: "64px",
      height: "64px",
    },
    margin: "0",
  },
  fieldError: {
    ...darkModeField,
    "&.MuiOtpInput-TextField": {
      width: "64px",
      height: "64px",
    },
    margin: "0",
    "& label.Mui-focused": {
      color: Colors.error,
    },
    "& label": {
      color: Colors.error,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: Colors.error,
      },
      "&:hover fieldset": {
        borderColor: Colors.error,
      },
      "&.Mui-focused fieldset": {
        borderColor: Colors.error,
      },
    },
  },
};

const FormikOtp: React.FC<IProps> = ({ formik, name, sx }) => {
  return (
    <FormControl variant="outlined">
      <MuiOtpInput
        sx={
          formik.touched[name] && Boolean(formik.errors[name])
            ? classes.fieldError
            : classes.field
        }
        value={formik.values[name]}
        onChange={(value: any) => {
          formik.setFieldValue(name, value);
        }}
      />
      {formik.touched[name] && formik.errors[name] && (
        <FormHelperText
          error={formik.touched[name] && Boolean(formik.errors[name])}
        >
          {formik.touched[name] && formik.errors[name]}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default FormikOtp;
